import { render, staticRenderFns } from "./modalGuiaObservacaoResposta.vue?vue&type=template&id=3d57a4d5&"
import script from "./modalGuiaObservacaoResposta.vue?vue&type=script&lang=js&"
export * from "./modalGuiaObservacaoResposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports